function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        font-size: 91px;\n        font-family: TrebuchetMS-Bold, Trebuchet MS;\n        font-weight: 700;\n      }\n\n      .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-7 {\n        clip-path: url(#clip-path-3);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(0.01 0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 127.32,
  height: 120.56
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(0.01 0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 222.12,
  y: 11.73,
  width: 82.67,
  height: 95.94
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(0.01 0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 419.36,
  y: 0.09,
  width: 126.81,
  height: 120.07
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "mainLogo");

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(148.05 98.01)"
}, "+")), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(337.26 98.2)"
}, "=")), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M39.41,96.91l-2.1,20a3.91,3.91,0,0,1-3.8,3.44H22.74a3,3,0,0,1-3.1-3,2.36,2.36,0,0,1,0-.46l2.1-20H3.14a3.1,3.1,0,0,1-3.15-3,3.83,3.83,0,0,1,0-.47l1.15-10.9A4,4,0,0,1,5,79H23.64l3.92-37.25H7.66a3.14,3.14,0,0,1-3.21-3.07,3.87,3.87,0,0,1,0-.48L5.65,27.09a4,4,0,0,1,3.92-3.55h19.9l2.12-20.1A3.91,3.91,0,0,1,35.39,0H46.16a3,3,0,0,1,3.1,3,2.43,2.43,0,0,1,0,.47l-2.12,20.1h39l2.1-20.06A4,4,0,0,1,92.1,0H103a3.09,3.09,0,0,1,3.14,3,3.71,3.71,0,0,1,0,.47L104,23.54h20a3.13,3.13,0,0,1,3.2,3.08,2.5,2.5,0,0,1,0,.47L126,38.23a4,4,0,0,1-3.93,3.55h-20L98.16,79h21.39a3.08,3.08,0,0,1,3.14,3,2.5,2.5,0,0,1,0,.47l-1.15,10.9a4,4,0,0,1-3.85,3.49H96.28l-2.1,20a4,4,0,0,1-3.84,3.48H79.45a3.08,3.08,0,0,1-3.14-3,3.71,3.71,0,0,1,0-.47l2.1-20ZM84.28,41.78H45.39L41.87,78.92,80.46,79Z",
  transform: "translate(0.01 0)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M222.12,107.34l1-6.2c2.21-13.29,14.8-24.08,28.08-24.08h33.11c13.29,0,22.28,10.79,20.08,24.08l-1,6.2Z",
  transform: "translate(0.01 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M270.7,11.73c15.39,0,26.82,12.14,25.51,27.09S281.35,65.91,266,65.91s-26.83-12.14-25.52-27.09S255.3,11.73,270.7,11.73Z",
  transform: "translate(0.01 0)"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M458.62,96.61l-2.1,19.93a3.89,3.89,0,0,1-3.78,3.42H442a3,3,0,0,1-3.09-3,3.46,3.46,0,0,1,0-.46L441,96.61H422.48a3.07,3.07,0,0,1-3.13-3,3.55,3.55,0,0,1,0-.46l1.14-10.87a4,4,0,0,1,3.84-3.47h18.55l3.9-37.1H427a3.13,3.13,0,0,1-3.2-3.06,3.87,3.87,0,0,1,0-.48L425,27.08a4,4,0,0,1,3.91-3.54h19.82l2.1-20A3.91,3.91,0,0,1,454.6.09h10.73a3,3,0,0,1,3.09,3,2.4,2.4,0,0,1,0,.46l-2.1,20h38.86l2.1-20A4,4,0,0,1,511.09.09h10.85a3.06,3.06,0,0,1,3.12,3,2.5,2.5,0,0,1,0,.47l-2.1,20h19.9A3.11,3.11,0,0,1,546,26.6a2.57,2.57,0,0,1,0,.48l-1.17,11.09a4,4,0,0,1-3.91,3.54H521l-3.9,37.1h21.3a3.06,3.06,0,0,1,3.13,3,3.55,3.55,0,0,1,0,.46l-1.14,10.87a4,4,0,0,1-3.83,3.46H515.25l-2.09,19.89a3.93,3.93,0,0,1-3.82,3.46H498.49a3,3,0,0,1-3.12-3,2.43,2.43,0,0,1,0-.47l2.09-19.89Zm5.78-19.15.39-2.31a11,11,0,0,1,10.47-9h12.35a7.42,7.42,0,0,1,7.65,7.17,7.31,7.31,0,0,1-.16,1.81l-.39,2.31ZM482.52,41.8a9.26,9.26,0,0,1,9.55,8.94,11.16,11.16,0,0,1,0,1.16A11.42,11.42,0,0,1,480.75,62a9.25,9.25,0,0,1-9.55-8.94,9.06,9.06,0,0,1,0-1.16,11.42,11.42,0,0,1,11.28-10.1Z",
  transform: "translate(0.01 0)"
})));

var SvgMainLogo = function SvgMainLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 546.04 122.73",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainLogo.5eb16f90.svg";
export { ForwardRef as ReactComponent };